import { makeStyles } from "@material-ui/core";
import { color } from "../../assets/const/color";

export const useStyles = makeStyles(() => ({
  root: {
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  login_again: {
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
}));
